<template>
  <modal
    name="modal-ajuda-editor-novo"
    scrollable
    :width="modalSize"
    height="auto"
    class="editor-help-modal"
  >
    <section class="editor-help" aria-labelledby="editor-help-title">
      <header class="editor-help__header">
        <div class="editor-help__heading">
          <span class="editor-help__icon" aria-hidden="true">
            <i class="fas fa-route"></i>
          </span>
          <div>
            <span class="editor-help__eyebrow">GUIA RÁPIDO</span>
            <h2 id="editor-help-title">Monte seu fluxo</h2>
            <p>Organize as etapas e acompanhe o caminho da conversa.</p>
          </div>
        </div>
        <button
          type="button"
          class="editor-help__close"
          aria-label="Fechar ajuda"
          @click="$modal.hide('modal-ajuda-editor-novo')"
        >
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </header>

      <div class="editor-help__content">
        <section class="editor-help__section">
          <h3><span>01</span> Comece pelo básico</h3>
          <div class="editor-help__steps">
            <article>
              <span
                class="editor-help__step-icon editor-help__step-icon--purple"
              >
                <i class="fas fa-plus" aria-hidden="true"></i>
              </span>
              <div>
                <strong>Adicione estágios</strong>
                <p>
                  Escolha uma etapa na biblioteca, como enviar mensagem ou
                  aguardar uma resposta.
                </p>
              </div>
            </article>
            <article>
              <span class="editor-help__step-icon editor-help__step-icon--blue">
                <i class="fas fa-project-diagram" aria-hidden="true"></i>
              </span>
              <div>
                <strong>Conecte as etapas</strong>
                <p>
                  Ligue a saída de um estágio à entrada do próximo para definir
                  a sequência.
                </p>
              </div>
            </article>
            <article>
              <span
                class="editor-help__step-icon editor-help__step-icon--green"
              >
                <i class="fas fa-sliders-h" aria-hidden="true"></i>
              </span>
              <div>
                <strong>Configure e teste</strong>
                <p>
                  Abra as opções pelos três pontos do cartão, preencha os campos
                  e teste a conversa.
                </p>
              </div>
            </article>
          </div>
        </section>

        <section class="editor-help__section editor-help__section--shortcuts">
          <div class="editor-help__section-heading">
            <div>
              <span class="editor-help__eyebrow">PRODUTIVIDADE</span>
              <h3>Atalhos do editor</h3>
            </div>
            <span class="editor-help__hint"
              >Use quando o canvas estiver ativo</span
            >
          </div>
          <div v-if="reteCanvas" class="editor-help__shortcut-grid">
            <div class="editor-help__shortcut">
              <span><kbd>F</kbd></span>
              <p>Buscar valores nos campos do fluxo</p>
            </div>
            <div class="editor-help__shortcut">
              <span><kbd>A</kbd></span>
              <p>Adicionar um estágio no centro</p>
            </div>
            <div class="editor-help__shortcut">
              <span><kbd>Shift</kbd><b>+</b><kbd>A</kbd></span>
              <p>Adicionar estágio conectado ao selecionado</p>
            </div>
            <div class="editor-help__shortcut">
              <span><kbd>Esc</kbd></span>
              <p>Fechar busca ou biblioteca; limpar seleção</p>
            </div>
            <div class="editor-help__shortcut">
              <span><kbd>0</kbd></span>
              <p>Enquadrar o fluxo todo</p>
            </div>
            <div class="editor-help__shortcut">
              <span><kbd>+</kbd><b>/</b><kbd>−</kbd></span>
              <p>Aumentar ou diminuir o zoom</p>
            </div>
          </div>
          <div v-else class="editor-help__shortcut-grid">
            <div class="editor-help__shortcut">
              <span><kbd>Ctrl</kbd><b>+</b><kbd>Z</kbd></span>
              <p>Desfazer</p>
            </div>
            <div class="editor-help__shortcut">
              <span
                ><kbd>Ctrl</kbd><b>+</b><kbd>Shift</kbd><b>+</b
                ><kbd>Z</kbd></span
              >
              <p>Refazer</p>
            </div>
            <div class="editor-help__shortcut">
              <span><kbd>Ctrl</kbd><b>+</b><kbd>D</kbd></span>
              <p>Duplicar estágio</p>
            </div>
            <div class="editor-help__shortcut">
              <span
                ><kbd>Ctrl</kbd><b>+</b><kbd>Alt</kbd><b>+</b><kbd>S</kbd></span
              >
              <p>Salvar fluxo</p>
            </div>
            <div class="editor-help__shortcut">
              <span><kbd>Del</kbd></span>
              <p>Remover estágio selecionado</p>
            </div>
            <div class="editor-help__shortcut">
              <span
                ><kbd>Ctrl</kbd><b>+</b><kbd>Alt</kbd><b>+</b><kbd>F</kbd></span
              >
              <p>Alternar tela cheia</p>
            </div>
          </div>
        </section>

        <aside v-if="reteCanvas" class="editor-help__tip">
          <i class="fas fa-lightbulb" aria-hidden="true"></i>
          <p>
            <strong>Dica:</strong> clique com o botão direito em uma área vazia
            do canvas para adicionar um estágio naquele ponto.
          </p>
        </aside>
      </div>
    </section>
  </modal>
</template>

<script>
export default {
  name: "ModalAjudaEditorNovo",
  props: {
    reteCanvas: { type: Boolean, default: false }
  },
  computed: {
    modalSize() {
      return window.innerWidth > 900 ? 860 : "92%";
    }
  }
};
</script>

<style lang="scss" scoped>
.editor-help {
  background: #fff;
  border-radius: 16px;
  color: #30283c;
  overflow: hidden;
}
.editor-help__header {
  align-items: flex-start;
  background: linear-gradient(125deg, #f5f0fb 0%, #f7f9ff 100%);
  border-bottom: 1px solid #ece7f2;
  display: flex;
  justify-content: space-between;
  padding: 28px 32px 24px;
}
.editor-help__heading {
  align-items: center;
  display: flex;
  gap: 16px;
}
.editor-help__icon {
  align-items: center;
  background: #7047a4;
  border-radius: 14px;
  box-shadow: 0 7px 16px #7047a433;
  color: #fff;
  display: flex;
  flex: 0 0 48px;
  height: 48px;
  justify-content: center;
}
.editor-help__eyebrow {
  color: #877799;
  display: block;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.1em;
  margin-bottom: 5px;
}
.editor-help h2,
.editor-help h3,
.editor-help p {
  margin: 0;
}
.editor-help h2 {
  color: #32263f;
  font-size: 22px;
  font-weight: 750;
}
.editor-help__header p {
  color: #786f81;
  font-size: 13px;
  margin-top: 5px;
}
.editor-help__close {
  align-items: center;
  background: #ffffffb8;
  border: 1px solid #e8e1ef;
  border-radius: 9px;
  color: #6e6379;
  cursor: pointer;
  display: flex;
  height: 34px;
  justify-content: center;
  width: 34px;
}
.editor-help__close:hover,
.editor-help__close:focus-visible {
  background: #fff;
  border-color: #cbb9dc;
  color: #57317d;
  outline: 0;
}
.editor-help__content {
  max-height: min(72vh, 680px);
  overflow-y: auto;
  padding: 26px 32px 30px;
}
.editor-help__section + .editor-help__section {
  margin-top: 28px;
}
.editor-help h3 {
  align-items: center;
  color: #40364c;
  display: flex;
  font-size: 15px;
  font-weight: 750;
  gap: 10px;
}
.editor-help__section > h3 > span {
  align-items: center;
  background: #f0e9f7;
  border-radius: 7px;
  color: #7047a4;
  display: inline-flex;
  font-size: 10px;
  height: 25px;
  justify-content: center;
  width: 29px;
}
.editor-help__steps {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 15px;
}
.editor-help__steps article {
  align-items: flex-start;
  background: #fff;
  border: 1px solid #ebe7ef;
  border-radius: 11px;
  display: flex;
  gap: 11px;
  min-height: 112px;
  padding: 15px 13px;
}
.editor-help__step-icon {
  align-items: center;
  border-radius: 8px;
  display: flex;
  flex: 0 0 30px;
  height: 30px;
  justify-content: center;
}
.editor-help__step-icon--purple {
  background: #f1eafa;
  color: #7047a4;
}
.editor-help__step-icon--blue {
  background: #eaf3ff;
  color: #347ac2;
}
.editor-help__step-icon--green {
  background: #eaf7f0;
  color: #32875b;
}
.editor-help__steps strong {
  color: #44394f;
  display: block;
  font-size: 12px;
  margin: 2px 0 5px;
}
.editor-help__steps p {
  color: #7b7383;
  font-size: 11px;
  line-height: 1.5;
}
.editor-help__section-heading {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin-bottom: 13px;
}
.editor-help__section-heading .editor-help__eyebrow {
  margin-bottom: 4px;
}
.editor-help__hint {
  color: #8b8292;
  font-size: 10px;
  padding-bottom: 2px;
}
.editor-help__shortcut-grid {
  background: #faf9fc;
  border: 1px solid #ece8f0;
  border-radius: 11px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  overflow: hidden;
}
.editor-help__shortcut {
  align-items: center;
  border-bottom: 1px solid #ece8f0;
  display: flex;
  gap: 12px;
  min-height: 52px;
  padding: 9px 13px;
}
.editor-help__shortcut:nth-child(odd) {
  border-right: 1px solid #ece8f0;
}
.editor-help__shortcut:nth-last-child(-n + 2) {
  border-bottom: 0;
}
.editor-help__shortcut > span {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 4px;
}
.editor-help kbd {
  background: #fff;
  border: 1px solid #e1dce7;
  border-bottom-width: 2px;
  border-radius: 5px;
  color: #51465e;
  font-family: inherit;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  padding: 5px 7px;
  white-space: nowrap;
}
.editor-help__shortcut b {
  color: #a39aa9;
  font-size: 10px;
  font-weight: 500;
}
.editor-help__shortcut p {
  color: #6f6678;
  font-size: 11px;
  line-height: 1.35;
}
.editor-help__tip {
  align-items: flex-start;
  background: #f5f1fa;
  border: 1px solid #e8def1;
  border-radius: 10px;
  color: #76589a;
  display: flex;
  gap: 10px;
  margin-top: 17px;
  padding: 12px 14px;
}
.editor-help__tip i {
  margin-top: 2px;
}
.editor-help__tip p {
  color: #645472;
  font-size: 11px;
  line-height: 1.5;
}
@media (max-width: 680px) {
  .editor-help__header {
    padding: 22px 20px 18px;
  }
  .editor-help__content {
    padding: 20px;
  }
  .editor-help__steps {
    grid-template-columns: 1fr;
  }
  .editor-help__steps article {
    min-height: 0;
  }
  .editor-help__shortcut-grid {
    grid-template-columns: 1fr;
  }
  .editor-help__shortcut:nth-child(odd) {
    border-right: 0;
  }
  .editor-help__shortcut:nth-last-child(2) {
    border-bottom: 1px solid #ece8f0;
  }
}
</style>
